import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  anonymous_listingWithActivityListData: any;
  anonymous_listingWithActivityListLoading: boolean;
  anonymous_listingWithActivityListError: SerializedError | null;
} = {
  anonymous_listingWithActivityListData: {},
  anonymous_listingWithActivityListLoading: false,
  anonymous_listingWithActivityListError: null,
};

export const anonymous_listingWithActivityListFunc = createAsyncThunk(
  'anonymous_listingWithActivityList/anonymous_listingWithActivityListFunc',
  async (values: { listingId: string }) => {
    const data = JSON.stringify({
      query: `query Anonymous_listingWithActivityList($listingId: String!) {
  anonymous_listingWithActivityList(listingId: $listingId) {
    _id
    activities {
      _id
      title
      listing {
        _id
        title
        category
        subCategory
        ageInterval
        format
        description
        images
        coverImage
        companionship
        rating {
          average
          numberOfReviews
          createdAt
          updatedAt
        }
        exteriorOrganizer {
          _id
          name
          imageUrl
          details
          socialMedia {
            website
            instagram
            twitter
            facebook
            youtube
          }
          contact {
            phoneNumber
            phoneNumber2
          }
          createdAt
          updatedAt
        }
      }
      schedule {
        _id
        repeatedIntervalType
        startDate
        endDate
        totalDayCount
        days {
          _id
          activity {
            _id
          }
          date
          day
          startTime
          endTime
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      location {
        _id
        city
        district
        country
        address {
          title
          description
        }
        lat
        long
        parking
      }
      additionalDetails
      quota
      hoursBeforeReservationExpires
      fee
      isReservationRequired
      externalLink
      externalMail
      externalPhoneNumber
      price
      duration
      status
      participantCount
      priority
      createdAt
      updatedAt
      createdBy {
        _id
        displayName
        displayImageUrl
        description
        role
      }
      updatedBy {
        _id
        displayName
        displayImageUrl
        description
        role
      }
    }
  }
}`,
      variables: {
        listingId: values?.listingId ?? null,
      },
    });

    const config = initialConfig(process.env.REACT_APP_BASE_URL_ACTIVITY || '', data, '');

    const response = axios(config)
      .then((res) => res.data)
      .catch((err) => err);

    return response;
  }
);

const anonymous_listingWithActivityList = createSlice({
  name: 'anonymous_listingWithActivityList',
  initialState,
  reducers: {
    clearAnonymousListingWithActivityListData: (state) => {
      state.anonymous_listingWithActivityListData = {};
      state.anonymous_listingWithActivityListError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(anonymous_listingWithActivityListFunc.pending, (state) => {
      state.anonymous_listingWithActivityListLoading = true;
    });
    builder.addCase(anonymous_listingWithActivityListFunc.fulfilled, (state, action) => {
      state.anonymous_listingWithActivityListLoading = false;

      // Detay sayfası için tüm aktiviteleri göster (filtreleme yapma)
      // Bu query detay sayfasında kullanıldığı için tüm aktiviteleri döndürmeliyiz
      const data = action.payload?.data?.anonymous_listingWithActivityList;
      state.anonymous_listingWithActivityListData = data || {};

      state.anonymous_listingWithActivityListError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(anonymous_listingWithActivityListFunc.rejected, (state, action) => {
      state.anonymous_listingWithActivityListLoading = false;
      state.anonymous_listingWithActivityListError = action.error;
    });
  },
});

export const { clearAnonymousListingWithActivityListData } =
  anonymous_listingWithActivityList.actions;
export default anonymous_listingWithActivityList.reducer;
